<template>
    <div class="ibox" >
        <div :class="[{'ibox-content custom-field-ibox-content custom-field-inquiry-mop':true ,'margin-t--30': attributes.length === 0}]">
            <!--  !isDependent ??  when admin clicks on the service then shows the service custom ( attribute, fields)
                only  only main   ( attribute, fields)  not sub  ( attribute, fields)
                -->
            <attribute v-if="!isDependent(attribute) && isNormal(attribute) && service.for_products !== 1" v-for="(attribute,index) of attributes"
                       v-model="attributes[index]"
                       @input="updateAttribute(index, $event)"
                       :date-format="dateFormat"
                       :time-format="timeFormat"
                       :attributes="attributes"
                       :currency="currency"
                       :clone="service.clone"
                       :unit="unit"
                       :item-id="itemId"
                       :key="index">
            </attribute>
        </div>
    </div>
</template>

<script>

// Reserved Attribute IDs
import {EventBus} from "../../../../events/event-bus";
import {isNormal, isReserved, isDependent, isHidden,isDeleted,isAvailable,isMandatory} from "@/events/sharedMethods.js";


export default {
    name: "attributes",
    props: {
        value: {
            type: Array,
            required: true,
            default() {
                return []
            }
        },
        dateFormat: {
            required: true
        },
        timeFormat: {
            required: true
        },
        service: {
            required: true
        },
        currency: {
            required: true
        },
        unit: {
            required: true
        },
        itemId: {},
    },
    data() {
        return {
            attributes: this.value,
        }
    },
    methods: {
        isNormal,isHidden,isReserved,isDeleted,isAvailable,isDependent,isMandatory,
        updateAttribute(index, newAttributeData) {
            this.$set(this.attributes, index, newAttributeData);
        }
    },
    watch: {
        attributes: {
            handler(newAttributes) {
                // this.$nextTick(() => {
                    EventBus.$emit('serviceChanged', JSON.parse(JSON.stringify(newAttributes)));
                    this.$emit('input', JSON.parse(JSON.stringify(newAttributes)));
                // });
            },
            deep: true,
            immediate: false // you can set it to true if you need to trigger on initialization
        }
    }

}
</script>

<style scoped>
.custom-field-ibox-content {
    background-color: #F5F5F6;
    border-radius: 8px;
    border-width: 0px 0px;
}
.margin-t--30 {
    margin-top: -30px;
}
</style>